import { useMemo } from 'react'

import { y } from '@circlefin/form'
import { L3OnboardingCryptoPaymentProportion } from '@shared/graphql'
import useTranslation from 'next-translate/useTranslation'

import { L3OnboardingDropdown } from '../../L3OnboardingDropdown'

import type { L3OnboardingDropdownVariantProps } from '../types'
import type { SelectListItem } from '@circlefin/components/lib/SelectList'

export const proportionOfPaymentsInCryptoSchema =
  y.mixed<L3OnboardingCryptoPaymentProportion>()

export const CryptoPaymentsProportion: React.FC<
  L3OnboardingDropdownVariantProps
> = (args) => {
  const { t } = useTranslation('l3Onboarding')

  const data: Array<SelectListItem<L3OnboardingCryptoPaymentProportion>> =
    useMemo(() => {
      const data = Object.values(L3OnboardingCryptoPaymentProportion)
        .filter((value) => value !== L3OnboardingCryptoPaymentProportion.zero)
        .map((option) => ({
          label: t(
            `forms.entityOperations.proportionOfPaymentsInCrypto.options.${L3OnboardingCryptoPaymentProportion[option]}`,
          ),
          value: L3OnboardingCryptoPaymentProportion[option],
        }))
      return [
        // Ensure '0%' option is the first to appear in the dropdown
        // Because generated GQL enums are sorted alphabetically
        {
          label: t(
            `forms.entityOperations.proportionOfPaymentsInCrypto.options.${L3OnboardingCryptoPaymentProportion.zero}`,
          ),
          value: L3OnboardingCryptoPaymentProportion.zero,
        },
        ...data,
      ]
    }, [t])

  return (
    <L3OnboardingDropdown
      items={data}
      label={t`forms.entityOperations.proportionOfPaymentsInCrypto.label`}
      {...args}
    />
  )
}
